import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { ShowHide }   from "./concerns/showHide";
import data from "@emoji-mart/data"
import { init } from "emoji-mart"

export default class extends Controller {

  static targets = ["detail", "detailToggle"]

  static values = {
    type: String,
    id: String,
  }

  static outlets = ["emoji-picker"]

  connect() {
    Loggable(this, {debug: false})
    ShowHide(this)
    init({ data }) // init emojis
    this.log("connected")
  }

  toggleDetail(event){
    this.log("toggleDetail")
    event.preventDefault()
    this.toggle(this.detailTarget)
    this.syncDetailToggles()
  }

  detailToggleTargetConnected() {
    this.syncDetailToggles()
  }

  detailTargetConnected() {
    this.syncDetailToggles()
  }

  syncDetailToggles() {
    if (!this.hasDetailTarget) return

    const expanded = String(!this.detailTarget.classList.contains("d-none"))
    this.detailToggleTargets.forEach(button => button.setAttribute("aria-expanded", expanded))
  }

  showEmojiPicker(event){
    this.log("showEmojiPicker")
    event.preventDefault()
    this.emojiPickerOutlet.showPicker(event, this.typeValue, this.idValue)
  }

}
